import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-paper-plane",
  "use": "icon-si-glyph-paper-plane-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-paper-plane\" id=\"icon-si-glyph-paper-plane\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>924</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M17,1.042 L11.436,14.954 L7.958,11.477 L8.653,13.563 L7.03,14.958 L7.03,11.563 L14.984,3.375 L6.047,9.969 L1,8.694 L17,1.042 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-paper-plane.svg
// module id = 4zy3
// module chunks = 62